export function setLoading(state, loading) {
    state.loading.module = loading
}

export function setDate(state, date){
    state.date = date
}




// WEBPACK FOOTER //
// ./src/modules/excel-inventory/mutations.js